import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class HillGallows1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.HILL_GALLOWS1;
}

export default HillGallows1PoiTileEntity;
